export class Net {

  netType: string = ''; // will be either Alaska Twist, Multi Strand, or Combination

  netName: string = ''; // will only be for the skipper's reference

  length: string = '';

  weedlineDepth: string = '';

  weedlineDepthUnits: string = '';

  hangRatio: string = '';

  meshSize: string = '';

  meshSizeFraction: string = '';

  numMeshes: string = '';

  numStrands: string = ''; //only needed for Alaska Twist

  isChecked: boolean = false;

  constructor(
    type: string = '',
    name: string = '',
    length: string = '',
    depth: string = '',
    depthUnits: string = '',
    ratio: string = '',
    mesh: string = '',
    meshFraction: string = '',
    numMeshes: string = '',
    strands: string = '',
    checked: boolean = false) {

    this.netType = type;
    this.netName = name;
    this.length = length;
    this.weedlineDepth = depth;
    this.weedlineDepthUnits = depthUnits;
    this.hangRatio = ratio;
    this.meshSize = mesh;
    this.meshSizeFraction = meshFraction;
    this.numMeshes = numMeshes;
    this.numStrands = strands;
    this.isChecked = checked;
  }

  public toString(): string {
    return this.netName;
  }

  public isValid(): boolean {

    let baseValid: boolean = !(!this.netName || !this.length || !this.weedlineDepth || !this.weedlineDepthUnits ||
      !this.hangRatio || !this.meshSize || !this.meshSizeFraction || !this.numMeshes);

    if (this.netType === "Alaska Twist") { // requires numStrands to be set
      return baseValid && !!this.numStrands;
    }
    else if (this.netType) { // does not require a value for numStrands
      return baseValid;
    }

    return false;

  }

  // transform anonymous data into net object
  public static transformAnonymous(net: any): Net {

    // if nets does not exist, set the default ones
    if (!net) {
      return new Net();
    }

    return new Net(
      net.netType ?? '',
      net.netName ?? '',
      net.length ?? '',
      net.weedlineDepth ?? '',
      net.weedlineDepthUnits ?? '',
      net.hangRatio ?? '',
      net.meshSize ?? '',
      net.meshSizeFraction ?? '',
      net.numMeshes ?? '',
      net.numStrands ?? '',
      net.isChecked ?? false
    );
  }

  // check if user nets are defined
  public static transformAnonArray(nets: any): Net[] {

    // if nets do not exist, set the default ones
    if (!nets) {
      return [];
    }

    let userNets: Net[] = [];
    for (let net of nets) {
      userNets.push(Net.transformAnonymous(net));
    }
    return userNets;

  }


  public isEqual(otherNet: Net) {
    return this.netType == otherNet.netType &&
    this.netName == otherNet.netName &&
    this.length == otherNet.length &&
    this.weedlineDepth == otherNet.weedlineDepth &&
    this.weedlineDepthUnits == otherNet.weedlineDepthUnits &&
    this.hangRatio == otherNet.hangRatio &&
    this.meshSize == otherNet.meshSize &&
    this.meshSizeFraction == otherNet.meshSizeFraction &&
    this.numMeshes == otherNet.numMeshes &&
    this.numStrands == otherNet.numStrands
  }
    
}
